module.exports = __webpack_public_path__ + "hero@2x.8cd3d34426043842b7a310c6b4cbcd91.png";


//////////////////
// WEBPACK FOOTER
// ./components/hero/assets/hero@2x.png
// module id = HBQd
// module chunks = 0